export const heroData = {
  title: "Frequently Asked Questions",
  subtitle: "Answers to common questions before your visit. For anything else, please contact us.",
  image:
    "https://readdy.ai/api/search-image?query=Helicopter%20interior%20cabin%20with%20warm%20ambient%20lighting%20showing%20panoramic%20window%20and%20leather%20seats%2C%20luxury%20aviation%20atmosphere%2C%20dark%20navy%20sky%20outside%2C%20clean%20and%20elegant%20composition%2C%20editorial%20photography%2C%20no%20text%2C%20high%20quality&width=1920&height=600&seq=faqhero01&orientation=landscape",
};

export const categories = [
  { id: "all", label: "All" },
  { id: "beginner", label: "First-Time Visitors" },
  { id: "booking", label: "Booking & Pricing" },
  { id: "day", label: "On the Day" },
  { id: "safety", label: "Safety & Operations" },
  { id: "gift", label: "Gift Tickets" },
];

export const faqItems = [
  {
    q: "Is it okay if it's my first time?",
    a: "Absolutely. The majority of our guests are first-timers. We will send detailed guidance in advance, and our staff will take good care of you on the day.",
    category: "beginner",
  },
  {
    q: "Are there any dress code requirements?",
    a: "Skirts and heels are fine, but since the helipad is outdoors, we recommend stable footwear. Please dress appropriately for the season.",
    category: "beginner",
  },
  {
    q: "What happens if it rains or there are strong winds?",
    a: "Safety is our top priority. Flights may be cancelled on the day due to weather at the operator's discretion. In that case, we will offer rescheduling or a full refund.",
    category: "safety",
  },
  {
    q: "How far in advance do I need to book?",
    a: "As a general rule, please apply at least 2 weeks before your desired date. During busy periods (Christmas, New Year's, Golden Week, etc.), we recommend booking at least 1 month in advance.",
    category: "booking",
  },
  {
    q: "Can I cancel my reservation?",
    a: "Yes, cancellations are possible. However, a cancellation fee may apply depending on the timing. Please refer to our Cancellation Policy page for details.",
    category: "booking",
  },
  {
    q: "What payment methods are accepted?",
    a: "We accept bank transfer and credit card payment. For gift ticket purchases, please complete the payment on the checkout page.",
    category: "booking",
  },
  {
    q: "Can I purchase this as a gift?",
    a: "Yes, gift tickets are available. You can give someone special a truly unique experience. Gift wrapping is also available.",
    category: "gift",
  },
  {
    q: "How early should I arrive on the day?",
    a: "Please arrive at the helipad at least 30 minutes before your scheduled boarding time. This allows enough time for check-in, the safety briefing, and any commemorative photos.",
    category: "day",
  },
  {
    q: "Is there parking if I come by car?",
    a: "Parking is available near the helipad. However, spaces are limited, so please let us know at the time of booking if you plan to drive.",
    category: "day",
  },
  {
    q: "Can I take photos and videos?",
    a: "Yes, you may take photos and videos with your smartphone or camera. Please be careful of vibration inside the cabin and avoid hitting the windows.",
    category: "day",
  },
  {
    q: "What kind of pilot will we have?",
    a: "Our pilots hold strict certification from the Ministry of Land, Infrastructure, Transport and Tourism (MLIT) and have accumulated extensive flight hours. They also take pride in communicating warmly with guests.",
    category: "safety",
  },
  {
    q: "Can pregnant guests fly?",
    a: "A doctor's note may be required for pregnant guests. Individual circumstances vary, even in the stable period, so please consult us in advance.",
    category: "safety",
  },
];
